import {
  GET_NOTIFICATION_REQUEST,
  GET_NOTIFICATION_SUCCESS,
  GET_NOTIFICATION_FAIL,
  MARK_NOTIFICATION_REQUEST,
  MARK_NOTIFICATION_SUCCESS,
  MARK_NOTIFICATION_FAIL,
} from "./notificationsTypes";
 

export const notificationsReducer = (state = { notifications: [] }, action) => {
  switch (action.type) {
    // GET
    case GET_NOTIFICATION_REQUEST:
      return { ...state, loading: true };
    case GET_NOTIFICATION_SUCCESS:
      return { ...state, loading: false, notifications: Array.isArray(action.payload) ? action.payload : [] };
    case GET_NOTIFICATION_FAIL:
      return { ...state, loading: false, error: action.payload };

    // MARK
    case MARK_NOTIFICATION_REQUEST:
      return { ...state, loading: true };
    case MARK_NOTIFICATION_SUCCESS:
      return { ...state, loading: false, updatedId: action.payload };
    case MARK_NOTIFICATION_FAIL:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};
